import React, {useEffect} from "react";
import {PermissionConst} from "../../services/enum/PermissionConst";
import CustomSelect from "../../components/general/CustomSelect";
import {UserDepartmentInterface} from "../../services/interface/UserDepartmentInterface";
import {showToast} from "../../components/general/CustomToast";
import {useTranslation} from "react-i18next";
import {useAssignDepartment} from "../../services/admin-user/apiPermission";

interface Props {
    item: UserDepartmentInterface;
}
export default function SelectPermission({item}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    const {mutate: assign, isPending: isLoading, data: successAssign} = useAssignDepartment()

    const [option, setOption] = React.useState<any>(
        (item.idPermission || item.idPermission === 0) && item.permission ?
            {idSelect: item.idPermission, descriptionData: item.permission} : null
    )

    useEffect(() => {
        if (successAssign) {
            showToast(t('assign-success'), 'success')
        }
    }, [successAssign]);

    return (
        <CustomSelect
            onChange={(e: any) => {
                showToast(t('accept-permission'), 'warning-success', () => {
                    assign({...item, idPermission: e})
                }, isLoading, () => {setOption(
                    (item.idPermission || item.idPermission === 0) && item.permission ?
                    {idSelect: item.idPermission, descriptionData: item.permission} : null
                )})
            }}
            options={PermissionConst}
            value={option}
            setValue={setOption}
        />
    )
}
